const AFMFont = require('../lib/font/afm')
module.exports = new AFMFont(require('./Helvetica.json'))